import Vue from 'vue'
import App from './App.vue'
import router from './router';
import './assets/css/global.css';
import './assets/css/common.css';
import './assets/css/animate.css';
import axios from 'axios'
import qs from 'qs';
import Vuex from 'vuex';
import permission from '@/mixin/index'
import store from './store/index';
import ElementUI from 'element-ui';
import Editor from './components/common/tinymce-editor.vue';
import 'element-ui/lib/theme-chalk/index.css'
// import "./assets/css/icon/iconfont.css"; //引入第三方字体图标
import {download, get, json, post, put, upload} from './request/http'
import common from './assets/js/common';
import globalVariable from './assets/js/globalVariable'
import dateTime from "./assets/js/dateTime";
import Preview from '@/components/common/Preview.vue';
import NavBar from '@/components/sysHome/NavBar.vue';
import Table from '@/components/common/Table.vue';
import Dialog from '@/components/common/Dialog.vue';
import RouteTitle from './components/common/RouteTitle.vue';
import defaultImg from './assets/image/default.webp';
import BottomSlider from '@/components/sysHome/BottomSlider.vue';
import NoData from './components/common/NoData.vue';
import userPng from './assets/image/user.png';
import CountTo from 'vue-count-to';
import TextOverflow from '@/components/common/TextOverflow.vue';
import { Message } from 'element-ui';
import "video.js/dist/video-js.css";
import { filterResDefault } from '@/utils/utils';
import debounce from '@/utils/utils';

import 'babel-polyfill';
/* eslint-disable no-new */
import Promise from 'es6-promise';

Vue.prototype.axios = axios;
Vue.prototype.$qs = qs;
Vue.directive('debounce',debounce);
Vue.use(Vuex);
Vue.mixin(permission)
Vue.use(ElementUI, { size: 'small', zIndex: 999 });

Vue.prototype.$get = get;
Vue.prototype.$post = post;
Vue.prototype.$upload = upload;
Vue.prototype.$download = download;
Vue.prototype.$json = json;
Vue.prototype.$default = defaultImg;
Vue.prototype.$user = userPng;
Vue.prototype.$put = put;
Vue.prototype.$virtual=require('./assets/image/resource/virtual.png');
Vue.prototype.$filterResDefault=filterResDefault;
Vue.prototype.$msg = (data)=>{
   let messageCase=store.state.common.messageCase;
   messageCase&&messageCase.close();
   const message=Message({
    message: data.message||'',
    showClose: data.showClose||true,
    type: data.type||"success",
    duration: data.duration||2 * 1000
})
store.commit('common/changeMessageCase',message);
};
var height=window.innerHeight;
Vue.prototype.$innerHeight=height;
Vue.prototype.$permission=(sign)=>{
  var data=store.state.menu.permissions||[];
  var el=data.find(item=>item==sign);
  if(el)return true;
  return false;
};
Vue.prototype.$severUrl=(url)=>{
  if(url.includes('://whzdzx.zdzxtech.cn')){
    return url;
  }else{
    return process.env.VUE_APP_OSS_IP+url;
  }};
Vue.prototype.$profile=require('./assets/image/person/user.png');
Vue.config.productionTip = false;

Vue.prototype.common = common;
Vue.prototype.commonsVariable = globalVariable;

Vue.prototype.$dateTime = dateTime;
Vue.component('Preview',Preview);
Vue.component('Table',Table);
Vue.component('Dialog',Dialog);
Vue.component('TinymceEditor',Editor);
Vue.component('RouteTitle',RouteTitle);
Vue.component('CountTo',CountTo);
Vue.component('NoData',NoData);
Vue.component('BottomSlider',BottomSlider);
Vue.component('NavBar',NavBar);
Vue.component('TextOverflow',TextOverflow);
Promise.polyfill();
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
